import { render, staticRenderFns } from "./timeliness.vue?vue&type=template&id=91cbbb5e&scoped=true&"
import script from "./timeliness.vue?vue&type=script&lang=js&"
export * from "./timeliness.vue?vue&type=script&lang=js&"
import style0 from "./timeliness.vue?vue&type=style&index=0&id=91cbbb5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cbbb5e",
  null
  
)

export default component.exports